export const SkeletonQuestionCard = () => {
  return (
    <div className="bg-white rounded-lg border border-dashed border-dark-invirtus/20 p-4 animate-pulse">
      {/* Row 1: Controls skeleton */}
      <div className="flex items-center gap-3 mb-3">
        <div className="w-6 h-6 bg-dark-invirtus/10 rounded" />
        <div className="w-10 h-6 bg-dark-invirtus/10 rounded-full" />
        <div className="w-24 h-6 bg-dark-invirtus/10 rounded" />
        <div className="w-32 h-6 bg-dark-invirtus/10 rounded ml-auto" />
        <div className="w-16 h-6 bg-dark-invirtus/10 rounded" />
        <div className="w-8 h-8 bg-dark-invirtus/10 rounded" />
      </div>

      {/* Row 2: Text skeleton */}
      <div className="space-y-2">
        <div className="h-4 bg-dark-invirtus/10 rounded w-full" />
        <div className="h-4 bg-dark-invirtus/10 rounded w-3/4" />
      </div>
    </div>
  );
};
